import React from 'react';

import type { GetStaticProps, GetStaticPaths } from 'next';

import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { Mode } from '@/constants/Mode';
import { LearnArticleRouteQuery } from '../../queries/LearnArticleRouteQuery';
import { LearnArticleContentQuery } from '../../queries/LearnArticleContentQuery';
import { fetchGraphQL } from '../../queries/fetchGraphQL';

import { Article } from '../../components/learn/Article';
import type { Content } from '../../types/contentfulTypes';
import { SEO } from '../../components/SEO';

import type { NextPageWithLayout } from '../../types/layoutExtensions';

type ArticleContentType = {
  disclaimer?: string;
  showCta: boolean;
  title: string;
  content: Content;
};
const LearnArticle: NextPageWithLayout<ArticleContentType> = pageData => (
  <>
    <Navigation mode={Mode.LIGHT} />
    <Article {...pageData} />
    <Footer />
  </>
);

export const getStaticPaths: GetStaticPaths = async () => {
  const { data }: any = await fetchGraphQL(LearnArticleRouteQuery, false);

  return {
    paths: data?.publicSitePagesCollection?.items?.map(({ url }: { url: string }) => `/learn${url}`) ?? [],
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params = { url: '' } }) => {
  const { data }: any = await fetchGraphQL(LearnArticleContentQuery(`/${params.url}`), false);
  const page: any = data.publicSitePagesCollection.items[0];
  return {
    props: page,
  };
};

LearnArticle.getLayout = (page: any) => {
  const { seoTitle, seoDescription, ldJsonSchema, ogImage, url } = page.props.children[1].props;

  return (
    <>
      <SEO
        {...{ seoTitle, seoDescription, ldJsonSchema }}
        {...(ogImage ? { ogImageUrl: ogImage.url, ogImageWidth: ogImage.width, ogImageHeight: ogImage.height } : {})}
        fullPath={`/learn${url}`}
      />
      <div className="page">{page}</div>
    </>
  );
};

export default LearnArticle;
